module.exports = __webpack_public_path__ + "img/00banner white.baea6916.webp";